import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useReviewAndCreate } from './useReviewAndCreate';
import { PeopleSection } from '../../../admin-common/components/PeopleSection';
import { AllocationSummaryTable } from '../ReviewAndCreate/AllocationSummaryTable';
import { DatasetSummary } from '../ReviewAndCreate/DatasetSummary';
import { ProjectBasics } from '../ReviewAndCreate/ProjectBasics';
import { ReviewConceptAndAttributes } from '../ReviewAndCreate/ReviewConceptAndAttributes';

interface ReviewAndCreateProps {
  setRequiredFieldsFilled: (fieldsFilled: boolean) => void;
}

export const ReviewAndCreate = ({ setRequiredFieldsFilled }: ReviewAndCreateProps) => {
  const theme = useTheme();
  const {
    projectName,
    conditionAreaName,
    healthSystemName,
    annotatorNames,
    supervisorNames,
    addedConcepts,
    validationEncounterCount,
    testEncounterCount,
    trainingEncounterCount,
    allocationSummary,
    isAllocationSummaryLoading,
    isDataSplitSummaryLoading,
  } = useReviewAndCreate();
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ p: theme.spacing(4) }}>
        <ProjectBasics
          projectName={projectName}
          conditionAreaName={conditionAreaName}
          healthSystemName={healthSystemName}
        />
      </Box>
      <Box sx={{ p: theme.spacing(4) }}>
        <PeopleSection annotatorNames={annotatorNames} supervisorNames={supervisorNames} />
      </Box>

      <Box sx={{ display: 'flex', gap: theme.spacing(2), p: theme.spacing(4) }}>
        <Box sx={{ flexGrow: 1 }}>
          <ReviewConceptAndAttributes addedConcepts={addedConcepts} />
        </Box>

        <Box
          id="review-sidebar"
          sx={{
            width: '450px',
            p: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
          }}
        >
          <DatasetSummary
            validationEncounterCount={validationEncounterCount}
            testEncounterCount={testEncounterCount}
            trainingEncounterCount={trainingEncounterCount}
            isLoading={isDataSplitSummaryLoading}
          />
          <AllocationSummaryTable
            allocationSummary={allocationSummary}
            isLoading={isAllocationSummaryLoading}
          />
        </Box>
      </Box>
    </Box>
  );
};
